var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OTLPExporterBase, } from '@opentelemetry/otlp-exporter-base';
import { createLegacyOtlpBrowserExportDelegate } from '@opentelemetry/otlp-exporter-base/browser-http';
import { MultiplayerJsonTraceSerializer } from './MultiplayerJsonTraceSerializer';
import { MULTIPLAYER_OTEL_DEFAULT_TRACES_EXPORTER_URL } from './constants.base';
/**
 * Trace Exporters for Web with postMessage fallback
 */
var MultiplayerHttpTraceExporterBrowser = /** @class */ (function (_super) {
    __extends(MultiplayerHttpTraceExporterBrowser, _super);
    function MultiplayerHttpTraceExporterBrowser(config) {
        if (config === void 0) { config = {}; }
        var _this = this;
        var _config = __assign(__assign({}, config), { url: config.url || MULTIPLAYER_OTEL_DEFAULT_TRACES_EXPORTER_URL, headers: __assign(__assign({}, (config.headers || {})), config.apiKey
                ? { Authorization: config.apiKey }
                : {}) });
        _this = _super.call(this, createLegacyOtlpBrowserExportDelegate(_config, MultiplayerJsonTraceSerializer, 'v1/traces', { 'Content-Type': 'application/json' })) || this;
        _this.usePostMessage = false;
        _this.config = config;
        _this.postMessageType = config.postMessageType || 'MULTIPLAYER_SESSION_DEBUGGER_LIB';
        _this.postMessageTargetOrigin = config.postMessageTargetOrigin || '*';
        return _this;
    }
    MultiplayerHttpTraceExporterBrowser.prototype.export = function (spans, resultCallback) {
        var _this = this;
        if (this.usePostMessage) {
            this.exportViaPostMessage(spans, resultCallback);
            return;
        }
        _super.prototype.export.call(this, spans, function (result) {
            if (result.code === 0) {
                resultCallback(result);
            }
            else if (_this.config.usePostMessageFallback) {
                _this.usePostMessage = true;
                _this.exportViaPostMessage(spans, resultCallback);
            }
            else {
                resultCallback(result);
            }
        });
    };
    MultiplayerHttpTraceExporterBrowser.prototype.exportViaPostMessage = function (spans, resultCallback) {
        var _this = this;
        if (typeof window === 'undefined') {
            resultCallback({ code: 1 });
            return;
        }
        try {
            window.postMessage({
                action: 'traces',
                type: this.postMessageType,
                payload: spans.map(function (span) { return _this._serializeSpan(span); }),
            }, this.postMessageTargetOrigin);
            resultCallback({ code: 0 });
        }
        catch (e) {
            resultCallback({ code: 1 });
        }
    };
    MultiplayerHttpTraceExporterBrowser.prototype._serializeSpan = function (span) {
        return {
            _spanContext: span.spanContext(),
            name: span.name,
            kind: span.kind,
            links: span.links,
            ended: span.ended,
            events: span.events,
            status: span.status,
            endTime: span.endTime,
            startTime: span.startTime,
            duration: span.duration,
            attributes: span.attributes,
            parentSpanId: span.parentSpanId,
            instrumentationLibrary: span.instrumentationLibrary,
            droppedAttributesCount: span.droppedAttributesCount,
            droppedEventsCount: span.droppedEventsCount,
            droppedLinksCount: span.droppedLinksCount,
            resource: {
                attributes: span.resource.attributes,
                asyncAttributesPending: span.resource.asyncAttributesPending,
            },
        };
    };
    MultiplayerHttpTraceExporterBrowser.prototype.getDefaultUrl = function (config) {
        return config.url || MULTIPLAYER_OTEL_DEFAULT_TRACES_EXPORTER_URL;
    };
    return MultiplayerHttpTraceExporterBrowser;
}(OTLPExporterBase));
export { MultiplayerHttpTraceExporterBrowser };
//# sourceMappingURL=MultiplayerHttpTraceExporterBrowser.js.map